import { render, staticRenderFns } from "./MyTickerSetting_nw_MOB.vue?vue&type=template&id=dc12ed84&scoped=true"
import script from "./MyTickerSetting_nw_MOB.vue?vue&type=script&lang=js"
export * from "./MyTickerSetting_nw_MOB.vue?vue&type=script&lang=js"
import style0 from "./MyTickerSetting_nw_MOB.vue?vue&type=style&index=0&id=dc12ed84&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dc12ed84",
  null
  
)

export default component.exports